import { PermissionsFn } from '~/core/PermissionGuard';

// Exports
export const permissions: PermissionsFn = (context) => {
  return context.flags.productsSettingsFundingRequestsPermissions;
};
